import { buildUrl } from '@/helpers.js'
import Vue from 'vue'

Vue.filter('buildUrl', function (path) {
  return buildUrl(path)
})